import { useCallback, useState } from 'react';

export function usePurchaseOrderDocumentDialog() {
  const [dialogOpen, setDialogOpen] = useState(false);

  const openAddDocumentDialog = useCallback(() => {
    setDialogOpen(true);
  }, []);

  return {
    dialogOpen,
    onDialogOpenChange: setDialogOpen,
    openAddDocumentDialog,
  };
}
